var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShape6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1036,
    viewBox: "0 0 1920 1036",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_638_1689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1036
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 1018.79C1920 1028.3 1914.34 1036 1907.37 1036H12.6316C5.6554 1036 0 1028.3 0 1018.79V17.2094C0 7.70496 5.6554 0 12.6316 0H1907.37C1914.34 0 1920 7.70496 1920 17.2094V1018.79Z",
    fill: "#1C1C1C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_638_1689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.466 252.067C365.466 252.067 99.6271 463.656 -264.552 463.263C-628.76 462.881 -72.7093 -220.444 -72.7093 -220.444C-72.7203 -220.421 -103.532 -181.853 -103.532 -181.853",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.977 267.793C350.977 267.793 87.2359 486.374 -277.374 483.368C-641.967 480.361 -93.0066 -227.791 -93.0066 -227.791C-93.0176 -227.767 -123.428 -187.795 -123.428 -187.795",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.092 284.007C336.092 284.007 74.4241 509.604 -290.599 503.972C-655.619 498.337 -113.7 -234.618 -113.7 -234.618C-113.711 -234.595 -143.722 -193.218 -143.722 -193.218",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.64 300.945C320.64 300.945 61.0286 533.56 -304.427 525.305C-669.89 517.045 -134.977 -240.72 -134.977 -240.72C-134.988 -240.696 -164.603 -197.914 -164.603 -197.914",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.124 317.968C305.124 317.968 47.5621 557.582 -318.34 546.706C-684.241 535.828 -156.322 -246.759 -156.322 -246.759C-156.334 -246.735 -185.554 -202.548 -185.554 -202.548",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.519 335.075C289.519 335.075 33.9832 581.713 -332.387 568.218C-698.769 554.716 -177.786 -252.695 -177.786 -252.695C-177.797 -252.671 -206.624 -207.078 -206.624 -207.078",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.87 352.278C273.87 352.278 20.3451 605.944 -346.536 589.822C-713.417 573.699 -199.334 -258.546 -199.334 -258.546C-199.346 -258.522 -227.781 -211.523 -227.781 -211.523",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.159 369.552C258.159 369.552 6.62838 630.247 -360.75 611.486C-728.125 592.748 -220.933 -264.348 -220.933 -264.348C-220.945 -264.322 -248.992 -215.915 -248.992 -215.915",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-154.618 620.878C-154.618 620.878 285.426 487.643 400.616 176.5C515.803 -134.618 -809.195 37.4129 -809.195 37.4129L-734.552 28.1922",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-175.065 635.737C-175.065 635.737 257.319 499.503 375.184 189.705C493.055 -120.091 -805.005 62.7141 -805.005 62.7141L-731.888 52.8823",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-195.681 653.1C-195.681 653.1 229.04 513.871 349.571 205.419C470.109 -103.031 -800.976 90.522 -800.976 90.522L-729.386 80.0816",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216.494 670.637C-216.494 670.637 200.559 528.416 323.759 221.29C446.966 -85.8342 -797.151 118.478 -797.151 118.478L-727.088 107.428",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237.479 688.352C-237.479 688.352 171.894 543.166 297.754 237.366C423.609 -68.4102 -793.527 146.629 -793.527 146.629L-724.993 134.971",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-258.656 706.147C-258.656 706.147 143.044 557.976 271.544 253.526C400.048 -50.9233 -790.116 174.856 -790.116 174.856L-723.109 162.59",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-280.658 723.465C-280.658 723.465 113.367 572.314 244.495 269.214C375.629 -33.8853 -787.579 202.601 -787.579 202.601L-722.1 189.729",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-302.977 740.725C-302.977 740.725 83.3662 586.597 217.112 284.848C350.874 -16.9219 -785.347 230.264 -785.347 230.264L-721.396 216.784",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-326.666 756.954C-326.666 756.954 51.983 599.875 188.355 299.434C324.721 -0.982789 -784.508 256.89 -784.508 256.89L-722.085 242.805",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-351.411 772.414C-351.411 772.414 19.5492 612.366 158.514 313.278C297.483 14.1926 -784.765 282.764 -784.765 282.764L-723.869 268.073",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-377.158 787.148C-377.158 787.148 -13.8916 624.134 127.651 326.401C269.198 28.6689 -786.052 307.905 -786.052 307.905L-726.685 292.608",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-403.8 801.188C-403.8 801.188 -48.233 635.212 95.8729 338.834C239.994 42.4355 -788.289 332.339 -788.289 332.339L-730.449 316.44",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-430.572 814.416C-430.572 814.416 -82.7207 645.505 63.9516 350.44C210.618 55.398 -790.646 355.921 -790.646 355.921L-734.335 339.418",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-457.358 826.908C-457.358 826.908 -117.217 655.043 31.9835 361.336C181.188 67.6294 -793.074 378.803 -793.074 378.803L-738.292 361.698",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-482.31 838.272C-482.31 838.272 -149.891 663.457 1.82106 371.109C153.535 78.7611 -793.709 400.55 -793.709 400.55L-740.456 382.843",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-505.659 848.619C-505.659 848.619 -180.975 670.881 -26.7627 379.871C127.448 88.8602 -792.805 421.267 -792.805 421.267L-741.082 402.96",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape6);
export default __webpack_public_path__ + "static/media/bg-shape-6.dde510aefabf2d5288037c3400a3930f.svg";
export { ForwardRef as ReactComponent };